import { ContentBlock } from 'draft-js';

/**
 * @param  {ContentBlock} block
 * @return {bool} Whether the passed block has list type.
 */
export default function blockIsListItem(block) {
  return block instanceof ContentBlock &&
    ['unordered-list-item', 'ordered-list-item'].includes(block.getType());
}
